import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const BreadCrumbs = ({ title, actions, paths }) => (
  <div className="w-full mb-4">
    <div>
      <nav className="flex items-center text-sm leading-5 font-medium">
        {paths.map((path, index) => (
          <React.Fragment key={path.link}>
            <Link
              to={path.link}
              className="text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out"
            >
              {path.title}
            </Link>
            {paths.length - 1 !== index && (
              <svg
                className="flex-shrink-0 mx-2 h-5 w-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </React.Fragment>
        ))}
      </nav>
    </div>
    <div className="mt-2 flex md:items-center justify-between">
      <div className="flex-1 min-w-0">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
          {title}
        </h2>
      </div>
      <div className="mb-2 flex-shrink-0 flex md:mt-0 md:ml-4">{actions}</div>
    </div>
  </div>
);

BreadCrumbs.defaultProps = {
  paths: [],
  actions: null
};

BreadCrumbs.propTypes = {
  title: PropTypes.string.isRequired,
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  ),
  actions: PropTypes.node
};

export default BreadCrumbs;
